export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/**
 * Generates a short name from the first letters of each word in a string.
 * @param {string} name - The full name to be shortened.
 * @returns {string} - The short name.
 */
export function getShortName(name) {
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('')
}

export function formatURL(url) {
  return url.startsWith('/') ? url : '/' + url
}

export const getMediaImgURL = url => {
  return url ? (url?.indexOf('media.oneturf.news') !== -1 ? url : 'https://media.oneturf.news/' + url) : ''
}

export const footerConfig = (
  allRoutes,
  {
    FACEBOOK_URL,
    INSTAGRAM_URL,
    TWITTER_URL,
    YOUTUBE_URL,
    facebookIcon,
    twitterIcon,
    instagramIcon,
    youtubeIcon,
    googlePlay,
    appleStore,
    logo,
    CustomLink,
    MyImage
  }
) => {
  return {
    logo,
    description:
      'A globally recognized sports content platform covering the worlds biggest sports and esports subjects for die-hard sports enthusiasts.',
    links: [
      { label: 'About Us', href: allRoutes.aboutUs },
      { label: 'Privacy Policy', href: allRoutes.privacyPolicy },
      { label: 'Contact Us', href: allRoutes.contactUs },
      { label: 'Terms and Conditions', href: allRoutes.termsAndConditions },
      { label: 'Delete Account', href: '/delete-account' },
      { label: 'Disclaimer', href: allRoutes.disclaimer },
      { label: 'Advertise', href: allRoutes.advertiseWithUs }
    ],
    socialLinks: [
      { icon: youtubeIcon, href: YOUTUBE_URL, alt: 'youtube' },
      { icon: facebookIcon, href: FACEBOOK_URL, alt: 'facebook' },
      { icon: instagramIcon, href: INSTAGRAM_URL, alt: 'instagram' },
      { icon: twitterIcon, href: TWITTER_URL, alt: 'twitter' }
    ],
    appLinks: [
      {
        href: 'https://play.google.com/store/apps/details?id=com.oneturf.news.live',
        icon: googlePlay,
        alt: 'Google Play'
      },
      {
        href: 'https://apps.apple.com/in/app/oneturf-news-live-score/id6504330330',
        icon: appleStore,
        alt: 'Apple Store'
      }
    ],
    connectTextKey: 'Connect with us',
    downloadText: 'Get the App on',
    CustomLink,
    MyImage,
    pageRouterComp: true
  }
}

export const HOFListfilterData = [
  { from: 1950, to: 1960 },
  { from: 1961, to: 1970 },
  { from: 1971, to: 1980 },
  { from: 1981, to: 1990 },
  { from: 1991, to: 2000 },
  { from: 2001, to: 2010 },
  { from: 2011, to: 2020 },
  { from: 2021, to: 2030 }
]

export const convertDt24hFormat = data => {
  const t = new Date(Number(data))
  const dateWithTime = t.toLocaleString('en-gb', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'Asia/Kolkata'
  })
  return dateWithTime + ' ' + 'IST'
}

export const getRemainingTime = timestamp => {
  const diff = Math.max(timestamp - Date.now(), 0)
  const totalSeconds = Math.floor(diff / 1000)
  const days = String(Math.floor(totalSeconds / (3600 * 24))).padStart(2, '0')
  const hours = String(Math.floor((totalSeconds % (3600 * 24)) / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
  return `${days}:${hours}:${minutes}`
}
